import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import Login from "../containers/login/index";
import DashBoard from "../containers/dashboard/index";
import OtpVerification from "../containers/otp/otp";
import PrivateRoute from './private-route';
import PublicRoute from './public-route';
import CheckLogin from "./checkIslogin";
import Profile from "../containers/profile/index";
import Review from "../containers/review/index";
import ProjectsPage from "../containers/projects";
import Myprojects from "../containers/my-projects/index";
import Buyprojects from "../containers/buy-projects/index";
import Projectdetail from "../containers/project-detail/index";
import Buyprojectdetail from "../containers/buy-projects/buy-project-available-detail";
import BuyProjectContactDetail from "../containers/buy-projects/buy-project-contact-details.js";
import Myprojectinbiddingdetail from "../containers/my-projects/my-projects-inbidding-detail";
import Myprojectcompleteddetail from "../containers/my-projects/my-projects-completed-detail";
import Notification from "../containers/notifications/index";
import RegisterPAge from '../containers/register';
import Support from '../containers/support/index';
import Payment from '../containers/payment/index';
import TermsConditions from "../containers/terms-conditions/index";
import Faqs from '../containers/faqs/index';
import MyWorks from '../containers/my-works/index';
import MyWorksWiewer from "../containers/myWorksViewer";
import ForgotPassword from "../containers/forgot-password";
import PrivacyPolicy from "../containers/privacy-policy/index";
import ProPlus from "../containers/pro-plus/index";
import leadPayment from "../containers/lead-payment";
import NotFoundPage from "../containers/notFound/pageNotFound";
import GetReviess from "../containers/getReviews";
import WalletHistory from "../containers/wallet-history/index";
import NotificationSettings from "../containers/notification-settings/NotificationSettings.jsx";
import Header from "../layout/header.js";
import Footer from "../layout/footer.js";
import { logoutCookie } from "../utils";
import BidDetailsPriceContainer from "../containers/bidDetailsPrice";
import AddCoupon from "../containers/coupons";
import ProjectCategory from "../containers/addProject/ProjectCategory";
import ProjectFormGuest from "../containers/addProject/project-form-guest";
import SuccessPage from "../containers/addProject/success-page";
import ProjectEdit from "../containers/project-edit";   
import Rating from "../components/Rating";
export default function AppRouter() {
  return (
    <Router>
      <Header/>

      <Switch>
        <PublicRoute path="/login" restricted={true} component={Login} exact="true" />
        <PublicRoute path="/otp" restricted={false} component={OtpVerification} exact="true" />
        <PublicRoute path="/forgot-password" restricted={false} component={ForgotPassword} exact="true" />
        
        {/* Logout route - clears cookies and redirects to login */}
        <Route path="/logout" exact render={() => {
          logoutCookie();
          window.location.href = '/login';
          return null;
        }} />

        <CheckLogin path="/" restricted={false} exact="true" />

        <PublicRoute path="/register" restricted={true} component={RegisterPAge} exact="true" />
        <PublicRoute path="/support" component={Support} exact="true" />
        <PublicRoute path="/terms-conditions" component={TermsConditions} exact="true" />
        <PublicRoute path="/privacy-policy" component={PrivacyPolicy} exact="true" />
        <PublicRoute path="/project-category/:id?" component={ProjectCategory} exact={true} />
        <PublicRoute path="/projects/project-form/:id/:subId?" component={ProjectFormGuest} exact={true} />
        <PublicRoute path="/success/:id" component={SuccessPage} exact={true} />
        <PublicRoute path="/edit-project/:id" component={ProjectEdit} exact={true} />

        <PrivateRoute path="/dashboard" component={DashBoard} exact="true" />
        <PrivateRoute path="/profile" component={Profile} exact="true" />
        <PrivateRoute path="/notifications" component={Notification} exact="true" />
        <PrivateRoute path="/my-projects" component={Myprojects} exact="true" />
        <PrivateRoute path="/bid-details-price/:project_number/:project_id/:provider_project_id/:from" component={BidDetailsPriceContainer} exact="true" />
        <PrivateRoute path="/project-detail/:id/:from" component={Projectdetail} exact="true" />
        <PrivateRoute path="/provider-review/:project_id" component={Rating} exact="true" />
        <PrivateRoute path="/notification-settings" component={NotificationSettings} exact="true" />

        {/*<PrivateRoute path="/projects/:category/:tab" component={ProjectsPage} exact="true" />*/}
        {/*<PrivateRoute component={Review} path="/review" exact="true" />*/}
        {/* <PrivateRoute restricted={true} component={DashBoard} path="/dashboard" exact="true" /> */}
        {/*<PrivateRoute component={Buyprojects} path="/buy-projects" exact="true" />*/}
        {/*<PrivateRoute component={AddCoupon} path="/coupon/:project_id/:project_number/:provider_project_id" exact="true" />*/}
        {/*<PrivateRoute component={Faqs} path="/faqs" exact="true" />*/}
        {/*<PrivateRoute component={MyWorks} path="/my-works" exact="true" />*/}
        {/*<PrivateRoute component={MyWorksWiewer} path="/my-works/:id" exact="true" />*/}
        {/*<PrivateRoute component={WalletHistory} path="/wallet-history" exact="true" />*/}
        {/*<PrivateRoute component={Myprojectinbiddingdetail} path="/my-projects-inbidding-detail" exact="true" />*/}
        {/*<PrivateRoute component={Myprojectcompleteddetail} path="/my-project-completed-detail" exact="true" />*/}
        {/*<PrivateRoute component={BuyProjectContactDetail} path="/buy-project-contact-details" exact="true" />*/}
        {/*<PrivateRoute component={Payment} path="/payment" exact="true" />*/}
        {/*<PrivateRoute component={ProPlus} path="/pro-plus" exact="true" />*/}
        {/*<PrivateRoute component={leadPayment} path="/lead-payment/:id/:project_id" exact="true" />*/}
        {/*<PrivateRoute component={GetReviess} path="/get-reviews/:id" exact="true" />*/}

        <PublicRoute path="*" component={NotFoundPage} />
      </Switch>

      <Footer />
    </Router>
  );
}
